import { Spacer } from '@chakra-ui/react'
import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CircleBadge } from '~/components/shared/CircleBadge'
import { CircleBadgeVariant } from '~/components/shared/componentStyles/CircleBadge.style'
import { ReferButton } from '~/pages/WebPhone/ReferButton'
import { PresenceState } from '~/utils/xml'

import {
  ParkTargetVariants,
  useParkTargetStyle,
} from './componentStyles/ParkTarget.style'
import { normalizeWhitespace } from './utils/stringUtils'

interface ParkTargetProps {
  parkName: string
  parkExtension: string
  presence: PresenceState
  onPark: (parkExtension: string) => void
}
export const ParkTarget = ({
  parkName,
  parkExtension,
  presence,
  onPark,
}: ParkTargetProps) => {
  const { t } = useTranslation()
  const handleClick = () => {
    if (presence === PresenceState.Unavailable) return
    onPark(parkExtension)
  }

  let variant: ParkTargetVariants
  let presenceVariant: CircleBadgeVariant
  const isAvailable = presence !== PresenceState.Unavailable
  switch (presence) {
    case PresenceState.Available:
      variant = ParkTargetVariants.Available
      presenceVariant = CircleBadgeVariant.Green
      break
    case PresenceState.Unavailable:
      variant = ParkTargetVariants.Unavailable
      presenceVariant = CircleBadgeVariant.Red
      break
    default:
      variant = ParkTargetVariants.Default
      presenceVariant = CircleBadgeVariant.Gray
      break
  }

  const styles = useParkTargetStyle({ variant })

  // Extract layout properties to apply as native props (Chakra v3 requirement)
  const containerProps = {
    gap: styles.container?.gap,
    justifyContent: styles.container?.justifyContent,
    alignItems: styles.container?.alignItems,
  }

  return (
    <Flex css={styles.container} {...containerProps}>
      <CircleBadge variant={presenceVariant} />
      <Text css={styles.text} lineClamp={1}>
        {parkName}
      </Text>
      <Spacer />
      {isAvailable && (
        <ReferButton
          buttonText={t('parkTarget.buttonText')}
          ariaLabel={t('parkTarget.buttonAriaLabel', {
            name: normalizeWhitespace(parkName),
          })}
          onClick={handleClick}
          buttonStyles={styles.button}
          textStyles={styles.buttonText}
        />
      )}
    </Flex>
  )
}
